// Modelli delle API di sessione e MFA (POST /identity/session e successive).
// Sono scritti a mano, e non letti da src/app/api (generato), perché devono funzionare anche
// prima che l'API venga rigenerata con `npm run refresh` e perché le chiamate di sessione passano
// da SessionApiService, che non usa gli interceptor.

export interface ApiEnvelope<T> {
  result: boolean;
  message?: string;
  data: T;
}

/** Login completato. refresh_token e expires_in ci sono per i client che inviano X-Client-Auth: 2. */
export interface SessionTokens {
  access_token: string;
  refresh_token?: string;
  expires_in?: number;
  /** Presente solo se è stato chiesto di ricordare il dispositivo. */
  device_token?: string;
}

/** Password corretta ma serve ancora il secondo fattore. */
export interface MfaChallenge {
  mfa_required: true;
  /** true se l'utente deve prima configurare l'app autenticatore. */
  enrollment_required: boolean;
  /** Valido 5 minuti, non apre nessuna API. */
  mfa_token: string;
}

export type LoginResult = SessionTokens | MfaChallenge;

export const isMfaChallenge = (r: LoginResult): r is MfaChallenge =>
  (r as MfaChallenge).mfa_required === true;

export interface MfaSetup {
  /** Segreto in base32, per l'inserimento manuale. */
  secret: string;
  otpauth_uri: string;
  issuer: string;
  account_name: string;
}

export interface UserDevice {
  id: number;
  label: string | null;
  platform: string | null;
  user_agent: string | null;
  created_on: string;
  last_used_on: string;
  expires_on: string;
  /** Fino a quando il dispositivo salta la MFA al login; null se non è fidato. */
  trusted_until: string | null;
  active: boolean;
}

/** Campi MFA aggiunti a UserItem dal backend. */
export interface UserMfaFields {
  mfa_enabled?: boolean;
  mfa?: { enrolled_at: string | null } | null;
}
export type WithMfa<T> = T & UserMfaFields;

/** Codici di errore restituiti dal backend nel campo `code` della risposta. */
export enum SessionErrorCode {
  MFA_CLIENT_UPDATE_REQUIRED = 'MFA_CLIENT_UPDATE_REQUIRED',
  MFA_TOKEN_EXPIRED = 'MFA_TOKEN_EXPIRED',
  MFA_LOCKED = 'MFA_LOCKED',
  REFRESH_IN_PROGRESS = 'REFRESH_IN_PROGRESS',
}
